require('./helpers/bundle-manifest').register(JSON.parse("{\"hwbR1\":\"index.773e6e69.js\",\"6pYmK\":\"icons.c14567a0.svg\"}"));